import { AuthenticationRoutesNames } from "@shared/constans/authentication-routes-names.constans";

export const listOfAddressesWhichIsAvailableInMobileDevice = [
    `${ AuthenticationRoutesNames.authenticationModuleName + AuthenticationRoutesNames.share }`,
    `${ AuthenticationRoutesNames.share }`,
    '/panel/main?shareLinkId',
    'panel/vehicle?shareLinkId',
    '/authentication/handover',
    '/handover-view',
];
